"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarginTop = exports.getLogoHeight = exports.getBackgroundPosition = void 0;
var getBackgroundPosition = function (theme) {
    switch (theme) {
        case 'valtra':
            return 'center';
        case 'massey':
            return 'center';
        default:
            return 'left bottom';
    }
};
exports.getBackgroundPosition = getBackgroundPosition;
var getLogoHeight = function (theme, device) {
    switch (theme) {
        case 'valtra':
            switch (device) {
                case 'desktopLg':
                case 'laptopLg':
                case 'laptopSm':
                    return 69;
                case 'tabletLg':
                case 'tabletMd':
                case 'tabletSm':
                    return 48;
                case 'mobileLg':
                    return 65;
                case 'mobileSm':
                    return 58;
                case 'mobileXs':
                    return 43;
                default:
                    return 78;
            }
        case 'massey':
            switch (device) {
                case 'desktopLg':
                case 'laptopLg':
                case 'laptopSm':
                    return 135;
                case 'tabletLg':
                case 'tabletMd':
                case 'tabletSm':
                    return 65;
                case 'mobileLg':
                    return 70;
                case 'mobileSm':
                    return 75;
                case 'mobileXs':
                    return 81;
                default:
                    return 151;
            }
        case 'agco':
            switch (device) {
                case 'desktopLg':
                case 'laptopLg':
                case 'laptopSm':
                    return 74;
                case 'tabletLg':
                case 'tabletMd':
                case 'tabletSm':
                    return 43;
                case 'mobileLg':
                    return 45;
                case 'mobileSm':
                    return 45;
                case 'mobileXs':
                    return 45;
                default:
                    return 86;
            }
        case 'fendt':
            switch (device) {
                case 'desktopLg':
                case 'laptopLg':
                case 'laptopSm':
                    return 140;
                case 'tabletLg':
                case 'tabletMd':
                case 'tabletSm':
                case 'mobileLg':
                case 'mobileSm':
                case 'mobileXs':
                default:
                    return 121;
            }
        default:
            return 86;
    }
};
exports.getLogoHeight = getLogoHeight;
var getMarginTop = function (theme) {
    switch (theme) {
        case 'valtra':
            return 23;
        case 'massey':
            return 0;
        default:
            return 25;
    }
};
exports.getMarginTop = getMarginTop;
